<template>
    <div>
        <h2 class="mb-8">{{ __('store.plan_name') }}</h2>

        <div v-if="!storeUser" class="k-portlet__body">
            <div class="alert alert-danger" role="alert">
                <strong>
                    {{ __('plan.no_store_user') }}
                </strong>
            </div>
        </div>

        <form v-else>
            <div class="col-md-6">
                <form-group reference-id="plan_option" :error="form.errors.plan"
                            :label="__('plan.plan_title')">
                    <select v-model="form.plan" id="plan_option" class="text-capitalize form-control" :class="checkError(form.errors.plan)">
                        <option v-for="(limits, plan) in plans" :key="plan" :value="plan">{{ plan }}</option>
                    </select>
                </form-group>

                <form-group required reference-id="image_limit" :error="form.errors.image_limit"
                            :label="planImageLabel">
                    <input v-model="form.image_limit" type="text" id="image_limit" class="text-capitalize form-control" :class="checkError(form.errors.image_limit)"
                           required/>
                </form-group>

                <form-group required reference-id="product_limit" :error="form.errors.product_limit"
                            :label="planProductLabel">
                    <input v-model="form.product_limit" type="text" id="product_limit"
                           class="text-capitalize form-control" :class="checkError(form.errors.product_limit)" required/>
                </form-group>
            </div>

            <button id="submit-edit-plan-button"
                    class="btn btn-primary"
                    @click.prevent="submitForm"
                    :disabled="form.processing">
                {{ __('actions.send') }}
            </button>
        </form>
    </div>
</template>

<script>

import Navigation from './Nav/Navigation.vue'
import FormGroup from '@components/Form/FormGroup.vue'

export default {
    name: 'EditPlan',

    layout: Navigation,

    components: {FormGroup},

    props: {
        storeUser: Array,
        storeUuid: String,
        store: Object,
        siblingStores: Array,
        connectors: Array,
        plans: Object,
    },

    data() {
        return {
            form: this.$inertia.form({
                plan: this.store.attributes.plan ?? 'free',
                image_limit: 1,
                product_limit: this.store.attributes.plan === 'free' ? 0 : '50000',
            }),
        }
    },

    computed: {
        planImageLabel() {
            return `${this.__('plan.image_limit')}
                            <abbr data-toggle="tooltip" data-placement="bottom" data-html="true"
                                  title="${this.getTooltip('image')}">
                                <em>${this.__('plan.default')}</em>
                            </abbr>`
        },
        planProductLabel() {
            return `${this.__('plan.product_limit')}
                            <abbr data-toggle="tooltip" data-placement="bottom" data-html="true"
                                  title="${this.getTooltip('product')}">
                                <em>${this.__('plan.default')}</em>
                            </abbr>`
        },
    },

    methods: {
        submitForm() {
            this.form.post(this.$route('store.plan.update', this.storeUuid))
        },
        getTooltip(type) {
            let tooltip = ''
            for (const [plan, limits] of Object.entries(this.plans)) {
                if (type === 'image') {
                    tooltip += `${this.capitalizeFirstLetter(plan)}: 1<br>`
                } else {
                    tooltip += `${this.capitalizeFirstLetter(plan)}: ${limits[type]}<br>`
                }
            }

            return tooltip
        },
        capitalizeFirstLetter(text) {
            return text.charAt(0).toUpperCase() + text.slice(1)
        },
        checkError(message) {
            return message !== undefined ? 'is-invalid' : this.wasValidated
        },
    },
}
</script>
